import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

import { useAssignmentActions } from '../../contexts/assignment-actions-context';

interface DeleteAssignmentModalProps {
  open: boolean;
  data: { id: number; userName?: string; projectName?: string } | null;
  onClose: () => void;
}

/**
 * Confirmation modal for deleting assignments
 * Integrated with planner's assignment actions context for seamless deletion
 */
export function DeleteAssignmentModal({ open, data, onClose }: DeleteAssignmentModalProps) {
  const { t } = useTranslation('authenticated.planner', {
    keyPrefix: 'modals.deleteConfirmation',
  });
  const { deleteMutation } = useAssignmentActions();

  const handleConfirm = async (closeModal: () => void) => {
    if (!data?.id) return;

    await deleteMutation.mutateAsync({
      payload: { assignmentId: data.id },
      ui: { userName: data.userName, projectName: data.projectName },
    });
    closeModal();
  };

  return (
    <ConfirmationModal
      title={t('title')}
      message={t('message')}
      confirmText={t('confirm')}
      cancelText={t('cancel')}
      confirmVariant="destructive"
      open={open}
      onOpen={() => {}}
      onClose={onClose}
      onConfirm={handleConfirm}
      isLoading={deleteMutation.isPending}
    />
  );
}
